import { cn, FormatUtils } from '@shared/utils';
import { Text } from '@shared/widgets';

interface AccountInfoRowProps {
  className?: string;
  label: string;
  value: string;
}

export const AccountInfoRow = (props: AccountInfoRowProps) => {
  return (
    <li className={cn('flex items-baseline justify-between gap-3', props.className)}>
      <Text size='sm' color='secondary'>
        {props.label}
      </Text>
      <Text weight='medium' size='sm'>
        {FormatUtils.toSliceNumber(props.value)}
      </Text>
    </li>
  );
};
